import { useEffect, useState } from 'react'

const useToastInfo = () => {
  const [toastInfo, setToastInfo] = useState({
    show: false,
    message: '',
    type: 'error',
  })

  useEffect(() => {
    if (toastInfo.show) {
      setTimeout(() => {
        setToastInfo({ ...toastInfo, show: false })
      }, 2500)
    }
  }, [toastInfo])

  return { toastInfo, setToastInfo }
}

export default useToastInfo
